module.exports = __webpack_public_path__ + "static/media/banner1.4b31b912.webp";